import useCustomizerStore from "../../state/customizer";
import ToyotaCrown from "../webgl/Car/ToyotaCrown";

export default function ToyotaCrownShowroomModel({
  modelOverride,
  xOffset = 0,
  floorOffset = -0.95,
  depthOffset = -1.25,
}) {
  const selectedModel = useCustomizerStore((state) => state.model);
  const model = modelOverride ?? selectedModel;

  return (
    <group>
      <group
        key={`showroom-model-${model}`}
        position={[xOffset, floorOffset, depthOffset]}
        rotation={[0, Math.PI * 1.5, 0]}
      >
        <ToyotaCrown modelIndex={model} />
      </group>
    </group>
  );
}
